import React from "react";
import LogoGok from "../assets/logo-gok.png";
import LogoDult from "../assets/dult-logo.svg";
import LogoDultDark from "../assets/dult-logo-dark.svg";
import LogoBmtc from "../assets/logo-bmtc.png";
import LogoMetroFull from "../assets/logo-metro-full.svg";

const SectionLogos = () => (
  <div className="section-logos">
    <img className="section-logos-item" src={LogoGok} alt="Government of Karnataka"/>
    <img className="section-logos-item light" src={LogoDult} alt="Directorate of Urban Land Transport"/>
    <img className="section-logos-item dark" src={LogoDultDark} alt="Directorate of Urban Land Transport"/>
    <img className="section-logos-item rounded" src={LogoBmtc} alt="Government of Karnataka"/>
    <img className="section-logos-item" src={LogoMetroFull} alt="Government of Karnataka"/>
  </div>
);

export default SectionLogos;
